import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86673cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-content" }
const _hoisted_2 = { class: "news-tab-bar" }
const _hoisted_3 = ["onClick"]

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { FDRouter } from '@/utils/stock'
 


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const router = new FDRouter(useRouter())

const isDark = computed(() => (route.query.theme as string) !== 'light')

const tabs = [
  { key: 'overview',  label: '概览',    path: '/news/overview' },
  { key: 'optional',  label: '自选',    path: '/news/optional' },
  { key: 'live',      label: '7X24',   path: '/news/live' },
  { key: 'important', label: '要闻',    path: '/news/important' },
  { key: 'zhiyan',    label: '智研',    path: '/news/zhiyan' },
  { key: 'ipo',       label: 'IPO',    path: '/news/ipo' },
  { key: 'crypto',    label: '加密货币', path: '/news/crypto' },
]

const currentTab = computed(() => {
  const seg = route.path.split('/').pop()
  return seg || 'overview'
})

const goTab = (tab: { key: string; path: string; label: string }) => {
  router.push({ path: tab.path, query: route.query })
 
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["news-page", _unref(isDark) ? 'dark' : 'light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("div", {
          key: tab.key,
          class: _normalizeClass(["news-tab-item", { active: _unref(currentTab) === tab.key }]),
          onClick: ($event: any) => (goTab(tab))
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ])
  ], 2))
}
}

})